import { AutogenModelCustomerFuel, AutogenRowCustomerFuel } from "./autogen/AutogenModelCustomerFuel";

export class ModelCustomerFuel extends AutogenModelCustomerFuel<RowCustomerFuel> {
	constructor() {
		super(RowCustomerFuel);
	}
}

export class RowCustomerFuel extends AutogenRowCustomerFuel {
}